import type { Stroke, LiveDrawingsPosition } from '@twitch-draw/shared';

interface ActiveDrawingsPanelProps {
  strokes: Stroke[];
  displayDurationMs: number;
  position: LiveDrawingsPosition;
}

const BATCH_WINDOW_MS = 2000;

export function ActiveDrawingsPanel({ strokes, displayDurationMs, position }: ActiveDrawingsPanelProps) {
  if (strokes.length === 0) return null;

  const now = Date.now();
  const sorted = [...strokes].sort((a, b) => a.createdAt - b.createdAt);

  const batches: { key: string; name: string; color: string; minRemaining: number }[] = [];

  for (const stroke of sorted) {
    const remaining = Math.max(displayDurationMs - (now - stroke.createdAt), 0);
    const last = batches[batches.length - 1];

    if (last && last.key.startsWith(stroke.userId + ':') && Math.abs(stroke.createdAt - parseBatchTs(last.key)) < BATCH_WINDOW_MS) {
      last.minRemaining = Math.min(last.minRemaining, remaining);
    } else {
      batches.push({
        key: `${stroke.userId}:${stroke.createdAt}`,
        name: stroke.displayName,
        color: stroke.color,
        minRemaining: remaining,
      });
    }
  }

  batches.sort((a, b) => b.minRemaining - a.minRemaining);

  return (
    <div className={`active-drawings active-drawings--${position}`}>
      <h4>Live Drawings</h4>
      <div className="active-drawings__list">
        {batches.map((item) => (
          <div key={item.key} className="active-drawings__item">
            <span className="active-drawings__swatch" style={{ backgroundColor: item.color }} />
            <span className="active-drawings__name">{item.name}</span>
            <span className="active-drawings__time">{Math.ceil(item.minRemaining / 1000)}s</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function parseBatchTs(key: string): number {
  return Number(key.split(':')[1]) || 0;
}
